import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: '42px',
    transform: 'translateY(-50%)',
  },
  container: {
    background: theme.palette.primary.main,
    minWidth: 64,
    minHeight: 64,
    width: 64,
    height: 64,
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'none',
  },
  icon: {
    minWidth: 28,
    minHeight: 28,
    width: 28,
    height: 28,
    color: 'white',
  },
  drawer: {
    '& .MuiDrawer-paper': {
      padding: '40px 16px',
    },
  },

  info: {
    width: '100%',
    height: 'auto',
    padding: '8px 16px',
    paddingLeft: 24,
    borderLeft: `8px solid ${theme.palette.primary.main}`,
    background: theme.palette.primary.light,
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 24,
  },
  infoIcon: {
    width: 24,
    height: 'auto',
    color: theme.palette.primary.main,
  },
  infoContent: {
    paddingLeft: 16,
  },
}))

export default useStyles
